if ((typeof Shopify) === 'undefined') {
  Shopify = {};
}

Shopify.onError = function (t, r) {
  try {
    var e = JSON.parse(t.responseText);
    if (e.message) {
      alert(e.message + "(" + e.status + "): " + e.description);
    } else {
      alert("Error : " + Shopify.fullMessagesFromErrors(e).join("; ") + ".");
    }
  } catch (err) {
    console.error("Error parsing JSON response:", err, "Response text:", t.responseText);
    alert("An unexpected error occurred. Please try again.");
  }
};

Shopify.fullMessagesFromErrors = function (t) {
  var r = [];
  jQuery.each(t, function (t, e) {
    jQuery.each(e, function (e, a) {
      r.push(t + " " + a)
    })
  });
  return r;
};

/*=========================== Fix for Shopify.money_format only formatting in USD in expansion stores =========================== */
$(function () {
  if (Shopify.currency) {
    if (Shopify.currency.active == 'GBP' && Shopify.money_format.indexOf('£') === -1) {
      Shopify.money_format = '£{{amount}}';
    }
  }
});

/* Ajax API */

// -------------------------------------------------------------------------------------
// POST to cart/add.js returns the JSON of the line item associated with the added item.
// -------------------------------------------------------------------------------------

Shopify.addItem = function (items, callback) {
  for (let i = 0; i < items.length; i++) {
    items[i].quantity = items[i].quantity || 1;
  }

  if (Array.isArray(items) === false) {
    items = {
      'items': [items]
    };
  } else {
    items = {
      'items': items
    };
  }

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: items,
    dataType: "json",
    success: function (line_item) {
      let items = line_item.items;

      if ((typeof callback) === 'function') {
        Shopify.onItemAdded(items);
        // maybe move Shopify.onItemAdded to run after queue is clear???
        for (let i = 0; i < items.length; i++) {
          if (i > 0) {
            setTimeout(function () {
              notifyCustomer(items[i].url + ".js", items[i].variant_id, items[i].quantity);
            }, 500);
          } else {
            notifyCustomer(items[i].url + ".js", items[i].variant_id, items[i].quantity);
          }
        }

        callback(line_item);
      } else {
        Shopify.onItemAdded(items);
        for (let i = 0; i < items.length; i++) {
          if (i > 0) {
            setTimeout(function () {
              notifyCustomer(items[i].url + ".js", items[i].variant_id, items[i].quantity);
            }, 500);
          } else {
            notifyCustomer(items[i].url + ".js", items[i].variant_id, items[i].quantity);
          }
        }
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  });
};

Shopify.onItemAdded = function (items) {
  if (items.length > 1) {
    for (let i = 0; i < items.length; i++) {
      console.log(items[i].title + " was added to your shopping cart.");
    }
  } else {
    console.log(items[0].title + " was added to your shopping cart.");
  }
  Shopify.getCart();
};

// ---------------------------------------------------------
// GET cart.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.getCart = function (callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      Shopify.onCartUpdate(cart);
      let cart_count = document.querySelector('.cart__item-count');
      cart_count.innerText = cart.item_count;
      mobile_menu.rebuildCartLineOrder(cart.items);
    }
  });
};

Shopify.onCartUpdate = function (cart) {
  //update the item count for the cart
  if ($('.cart__item-count').text() != cart.item_count) {
    $('.cart__item-count').text(cart.item_count);
  }
  //update the total price in the cart
  $('.total-price').text(Shopify.formatMoney(cart.total_price));

  //update the free gift status bar price
  $('.free-gift__current-price').text(Shopify.formatMoney(cart.total_price));

  //update the free gift status in the cart
  function updateFreeGift() {
    let cart_items = document.querySelector('.cart-items');
    let progress_bar = document.querySelector('.progress-bar');

    clearTimeout(checkFreeGiftsTimer);
    checkFreeGiftsTimer = setTimeout(function () {
      Shopify.getCart(checkFreeGifts);
    }, 500);

    let difference_container = document.querySelector('.remaining-difference');
    let view_free_gift_btn = document.querySelector('.view-free-gifts');
    let tooltip_gifts = document.querySelector('.tooltip-qualifying-gifts');
    let free_gift_goal_container = document.querySelector('.free-gift-goal');
    let free_gift_prices = [100, 3000, 3500, 5000, 10000];
    let free_gifts = [
      'a FREE MŌDA® Prismatic 2pc Precision Powder Kit',
      'FREE Shipping',
      'a FREE MŌDA® Pro Glow Brush',
      'a FREE MŌDA® Scrubby Cleaning Pad',
      'a FREE MŌDA® Limited Edition 2pc Powder and Soft Glow Kit'
    ];
    let free_gift_images = [
      'https://cdn.shopify.com/s/files/1/0561/0261/files/FreeGift_Image_2_700x.jpg?v=1605109132',
      'https://cdn.shopify.com/s/files/1/0561/0261/files/FreeGift_Image_2_700x.jpg?v=1605109132',
      'https://cdn.shopify.com/s/files/1/0561/0261/files/FreeGift_Image_2_700x.jpg?v=1605109132',
      'https://cdn.shopify.com/s/files/1/0561/0261/files/FreeGift_Image_2_700x.jpg?v=1605109132',
      'https://cdn.shopify.com/s/files/1/0561/0261/files/FreeGift_Image_2_700x.jpg?v=1605109132'
    ];
    let qualifying_gifts_count = 0;
    let percentage_complete = 0;
    let remaining_difference = 0;
    if (cart.items.length == 0) {
      cart_items.innerHTML = "<h2 style='text-align: center;'>You have no items in your cart</h2>";
    }

    //check the total price against the free gift amounts to determine what they qualify for
    for (var i = 0; i < free_gifts.length; i++) {
      if (cart.total_price >= free_gift_prices[i]) {
        qualifying_gifts_count++;
      }
    }

    //see how close they are to the next free gift
    percentage_complete = (cart.total_price / free_gift_prices[qualifying_gifts_count]) * 100;
    if (qualifying_gifts_count === free_gift_prices.length) {
      percentage_complete = 100;
    }
    remaining_difference = free_gift_prices[qualifying_gifts_count] - cart.total_price;

    //set the progress bar width dependent on their percentage completed
    progress_bar.style.width = percentage_complete + "%";

    if (qualifying_gifts_count === free_gift_prices.length) {
      let free_gift_message_container = document.querySelector('.cart-freegifts__add-more');
      let free_gift_display = document.querySelector('.free-gift-display');
      free_gift_message_container.innerHTML = '<p>Your cart qualifies for all of our free gifts.</p>';
      free_gift_display.setAttribute('src', free_gift_images[free_gift_images.length - 1])
    } else {
      let free_gift_message_container = document.querySelector('.cart-freegifts__add-more');
      let free_gift_display = document.querySelector('.free-gift-display');
      let free_gift_message = "<p>Add " + Shopify.formatMoney(remaining_difference) + " more and receive " + free_gifts[qualifying_gifts_count] + "</p>";
      free_gift_display.setAttribute('src', free_gift_images[qualifying_gifts_count])
      free_gift_message_container.innerHTML = free_gift_message;
    }

    function updateToolTip() {
      let heading = document.querySelector('.tooltip-heading');
      if (qualifying_gifts_count === 0) {
        heading.innerText = "Your order doesnt qualify for any gifts yet.";
      } else {
        heading.innerText = "Your cart qualifies for:";
      }
      tooltip_gifts.innerHTML = "";
      for (var i = 0; i < qualifying_gifts_count; i++) {
        let list_item = createElement('li', 'class', 'free-gift-item');
        list_item.appendChild(document.createTextNode(free_gifts[i]));
        tooltip_gifts.appendChild(list_item);
      }
    }

    updateToolTip();
  }

  updateFreeGift();
};

Shopify.changeItem = function (t, r, s, e) {
  var o = {
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + r + "&" + s + "=" + t,
    dataType: "json",
    success: function (t) {
      "function" == typeof e ? e(t) : Shopify.onCartUpdate(t);
    },
    error: function (t, r) {
      Shopify.onError(t, r);
    }
  };
  jQuery.ajax(o);
};

Shopify.removeItem = function (t, s, r) {
  var e = {
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=0&" + s + "=" + t,
    dataType: "json",
    success: function (t) {
      "function" == typeof r ? r(t) : Shopify.onCartUpdate(t);
    },
    error: function (t, r) {
      Shopify.onError(t, r);
    }
  };
  jQuery.ajax(e);
};

Shopify.updateItem = function (data, r) {
  let sendData = {
    type: "POST",
    url: "/cart/update.js",
    data: {
      updates: data
    },
    dataType: "json",
    success: function (data) {
      "function" == typeof r ? r(data) : Shopify.onCartUpdate(data);
    },
    error: function (data) {
      Shopify.onError(data);
    }
  }
  jQuery.ajax(sendData);
};

Shopify.queue = [];

Shopify.moveAlong = function () {
  if (Shopify.queue.length) {
    var request = Shopify.queue.shift();
    Shopify.addItem({
      'id': request.variantId,
      'quantity': request.quantity,
      'properties': request.properties
    }, Shopify.moveAlong);
  } else {
    // check for free gift qualifications
  }
};

function push_to_queue(id, qty, properties, callback) {
  if (properties != false) {
    Shopify.queue.push({
      variantId: id,
      quantity: qty,
      properties: properties
    });
  } else {
    Shopify.queue.push({
      variantId: id,
      quantity: qty
    });
  }
  if (typeof callback === 'function') {
    callback();
  }
}

let freeGifts = [{
    "id": 37531743420586,
    "sku": "BMD-GIVE",
    "maxQty": 1,
    "qualifier": {
      "minCartValue": 3500
    }
  },
  {
    "id": 37542452330666,
    "sku": "BMD-PROMO1",
    "maxQty": 1,
    "qualifier": {
      "minCartValue": 5000,
      "timeframe": {
        "startDate": "2022-03-17 00:00:00 -0500",
        "endDate": "2026-03-22 02:00:00 -0500"
      }
    }
  },
  {
    "id": 37531778154666,
    "sku": "BMD-GIVE100",
    "maxQty": 1,
    "qualifier": {
      "minCartValue": 10000
    }
  },
  {
    "id": 46095365734570,
    "sku": "BMD-GIVE1",
    "maxQty": 1,
    "qualifier": {
      "minCartValue": 100
    }
  }
];

var checkFreeGiftsTimer;

function checkFreeGifts(cart) {
  let freeGiftsToAdd = [],
    freeGiftsToRemove = {};
  for (let i = 0; i < freeGifts.length; i++) {
    let giftRemoved = false,
      foundGiftInCart = false,
      foundTimeframeQualifier = false,
      timeframeQualifies = false,
      foundProductSkuQualifier = false,
      foundProductTypeQualifier = freeGifts[i].qualifier.hasOwnProperty("productType"),
      productTypeQualifies = false,
      cartItem = "";
    if (freeGifts[i].qualifier.hasOwnProperty("timeframe")) {
      foundTimeframeQualifier = true;
      if (withinTimeframe(freeGifts[i].qualifier.timeframe.startDate, freeGifts[i].qualifier.timeframe.endDate) === true) {
        timeframeQualifies = true;
      }
    }
    let arrayCartMatch = 0;
    for (let j = 0; j < cart.items.length; j++) {
      if (freeGifts[i].id == cart.items[j].id) {
        foundGiftInCart = true;
      }
      if (freeGifts[i].qualifier.hasOwnProperty("productSku")) {
        if (Array.isArray(freeGifts[i].qualifier.productSku) === true) {
          for (let l = 0; l < freeGifts[i].qualifier.productSku.length; l++) {
            if (cart.items[j].sku.indexOf(freeGifts[i].qualifier.productSku[l]) > -1) {
              arrayCartMatch++;
            }
            if (arrayCartMatch == freeGifts[i].qualifier.productSku.length) {
              foundProductSkuQualifier = true;
              if (foundProductTypeQualifier === true) {
                if (cart.items[j].product_type == freeGifts[i].qualifier.productType) {
                  productTypeQualifies = true;
                }
              }
              break;
            }
          }
        } else if (cart.items[j].sku.indexOf(freeGifts[i].qualifier.productSku) > -1) {
          foundProductSkuQualifier = true;
          if (foundProductTypeQualifier === true) {
            if (cart.items[j].product_type == freeGifts[i].qualifier.productType) {
              productTypeQualifies = true;
            }
          }
        }
      }
      if (foundProductTypeQualifier === true && foundProductSkuQualifier === false) {
        if (cart.items[j].product_type == freeGifts[i].qualifier.productType) {
          productTypeQualifies = true;
        }
      }
      if (cart.items[j].variant_id == freeGifts[i].id) {
        if (freeGifts[i].hasOwnProperty("maxQty")) {
          if (cart.items[j].quantity == freeGifts[i].maxQty) {
            cartItem = cart.items[j];
          } else {
            Shopify.changeItem(j++, freeGifts[i].maxQty, "line");
            break;
          }
        }
      }
    }
    if (freeGifts[i].qualifier.hasOwnProperty("minCartValue")) {
      let cartValue = freeGifts[i].qualifier.minCartValue;
      if (cart.total_price >= cartValue && foundGiftInCart === false && (foundTimeframeQualifier === false || (foundTimeframeQualifier === true && timeframeQualifies === true))) {
        freeGiftsToAdd.push({
          'id': freeGifts[i].id,
          'quantity': 1
        });
      } else {
        if (cart.total_price < cartValue && foundGiftInCart === true) {
          if (cartItem.product_type == "Free Gift") {
            freeGiftsToRemove[freeGifts[i].id] = 0;
          } else {
            freeGiftsToRemove[freeGifts[i].id] = 0;
          }
          giftRemoved = true;
          document.querySelector('.cart-details .remove-item[data-variant-id="' + freeGifts[i].id + '"]').parentNode.remove();
        }
      }
    } else if (freeGifts[i].qualifier.hasOwnProperty("productSku")) {
      if (foundProductSkuQualifier === true) {
        if (foundGiftInCart === false) {
          if ((foundTimeframeQualifier === false || (foundTimeframeQualifier === true && timeframeQualifies === true)) && (foundProductTypeQualifier === false || (foundProductTypeQualifier === true && productTypeQualifies === true))) {
            freeGiftsToAdd.push({
              'id': freeGifts[i].id,
              'quantity': 1
            });
          }
        }
        if (!document.querySelector('.cart-details').contains(document.querySelector('.remove-item[data-variant-id="' + freeGifts[i].id + '"]')) && cartItem != "") {
          // If we can't find the free gift in the popup, logic could go here.
        }
      } else {
        if (foundGiftInCart === true && cartItem.product_type == "Free Gift") {
          freeGiftsToRemove[freeGifts[i].id] = 0;
        }
      }
    }
  }

  if (freeGiftsToRemove && Object.keys(freeGiftsToRemove).length > 0 && freeGiftsToRemove.constructor === Object) {
    Shopify.updateItem(freeGiftsToRemove);
  } else {
    if (freeGiftsToAdd.length) {
      Shopify.addItem(freeGiftsToAdd);
    } else {
      mobile_menu.rebuildCartLineOrder(cart.items);
    }
  }
  stopLoader();
}
